import React, { PureComponent } from "react";
import MainHeader from "components/templateParts/MainHeader";
import SearchBar from "components/templateParts/SearchBar";
import SmartViewsSidebar from "../../../SmartViewsSidebar/SmartViewsSidebar";
import AddPostButton from "../../../ui_components/buttons/AddPostButton";
import Footer from "components/Footer/Footer";
import StatusBarContainer from "./StatusBarContainer";
import SmartTable from "components/ui_components/table/SmartTable";
import dataProvider, {
  UPDATE,
  GET_LIST,
  DOWNLOAD_FILE,
  UPDATE_LIST,
   GET_ONE,
  POST
} from "providers/dataProvider";
import helpers from "utils/helpers";
import {
  getSmartFilterConfig,
  tableColConfig,
} from "config/resources/requisitionsResource/index.js";
import { compose } from "redux";
import withModal from "withModal";
import DeliveryModalContainer from "components/pages/requisitions/RequisitionsShow/Tabs/ReportsDelivery/DeliveryModalContainer";
import Can from "Can";
import { userRoles, userGroups } from "config/userRoles";
import printBarcode from "printer/layout/printBarcode.js";
import printCryo from "printer/layout/printCryo.js";
import { TableHeaderAddButton } from "components/ui_components/buttons";
import Dymo from "printer/printer";
import { withNotificationCenter } from "NotificationCenter";
import {
  getExtraTableConfiguration,
  getDefaultExtraTableConfiguration,
  getResource,
} from "./reqListHelpers";
import { Delivery2Icon } from "icons";
import { withSmartFilter } from 'SmartFilterProvider';
import urlQuery from "urlQuery";
import { filter } from 'lodash';
import filterArrayConfigByPermissions from 'utils/filterArrayConfigByPermissions';
import { withAuthCenter } from 'AuthCenter'

const queryString = require("query-string");

const dymo = new Dymo({
  hostname: "127.0.0.1",
});

const extraDataConfig = {
  byId: ["reasonsFail", "reasonsPass", "labQcStatus", "flags", "depts"],
  byHash: {
    reasonsFail: {
      resource: "reasons/FAIL"
    },
    reasonsPass: {
      resource: "reasons/PASS",
    },
    labQcStatus: {
      resource: "lovs/LABQCSTATUS",
    },
    flags: {
      resource: "flags",
    },
    depts: {
      resource: "depts",
    }
  },
};

class RequisitionsListComponent extends PureComponent {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.query = queryString.parse(props.location.search);

    let initFilterStatus = tableColConfig.groupsByHash.hasOwnProperty(
      this.query.status
    )
      ? this.query.status
      : "All";

    if (helpers.can([userRoles.client])) {
      initFilterStatus = "AllForClient";
    } else if (helpers.can([userRoles.physician])) {
      initFilterStatus = "AllForPhysician";
       } else if (helpers.can([userRoles.billing])) {
      initFilterStatus = "BillingBatch";
      // For billing role, we'll show billing batch data with ID and billSendDate columns
      //   initFilterStatus = "Billing";
      // // For billing role, use Billing status which supports filtering
    }

    this.state = {
      currentFilterStatus: initFilterStatus,
      selectedRows: [],
      extraTableConfiguration: getDefaultExtraTableConfiguration(),
      resultsInputData: {},
      deliveryReqID: null,
      deliveryModalType: "",
      downloadReportsByFilterInProgress: false,
    };
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevStatus = urlQuery.getByKeyByQuery('status', prevProps.location.search);
    const currentStatus = urlQuery.getByKeyByQuery('status', this.props.location.search);
    if (prevStatus !== currentStatus) {
      const status = urlQuery.getByKeyByQuery('status', this.props.location.search) || 'All';
      console.log("handleChangeStatus2", status);
      this.smartTable.setPage({}, 0);
      this.setState({
        currentFilterStatus: status
      })
    }
  }

  handleSaveTestResults = (rows) => {
    const { resultsInputData } = this.state;

    const row = rows[0];
    const data = {
      reqTests: resultsInputData[row.id].resultsInputDataById.map((id) => {
        return {
          reqTestId: id,
          result: resultsInputData[row.id].resultsInputDataByHash[id],
        };
      }),
    };

    dataProvider(UPDATE, `requisitions/${row.id}/req_tests/bulk_edit`, {
      data: data,
    })
      .then((response) => {
        this.props.notificationCenter.show("Successfully updated", "info");
        this.smartTable.loadData();
        this.setState({
          resultsInputData: [],
        });
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
      });
  };

  handleChangeStatus = (status) => {
    this.setState(
      {
        currentFilterStatus: status,
      },
      () => {
        urlQuery.push({ status: status });
        this.smartTable.setPage({}, 0);
      }
    );
  };

  handlePrintCryoAction = (rows) => {
    try {
      printCryo(dymo, rows[0]);
    } catch (err) {
      console.error(err);
      this.props.notificationCenter.show("Printing error", "warning");
    }
  };

  handlePrintBarCodeAction = (rows) => {
    try {
      printBarcode(dymo, rows[0]);
    } catch (err) {
      console.error(err);
      this.props.notificationCenter.show("Printing error", "warning");
    }
  };

  handleBulkDownloadResultSource = (rows) => {
    this.handleBulkDownload(rows, "RESULT");
  };

  handleBulkDownloadReportSource = (rows) => {
    this.handleBulkDownload(rows, "REPORT");
  };

  handleBulkDownloadReleaseSource = (rows) => {
    this.handleBulkDownload(rows, "RELEASE");
  };

  handleBulkDownloadDeliverSource = (rows) => {
    // For billing role and BillingBatch status, use special handler
    if (helpers.can([userRoles.billing]) && this.state.currentFilterStatus === "BillingBatch") {
      this.handleBulkDownloadBillingBatches(rows);
    } else {
      this.handleBulkDownload(rows, "DELIVER");
    }
  };


  /**
   * Special handler for downloading requisitions from billing batches
   * For each selected batch, fetches its details to get requisition IDs
   * Then makes a direct API call to bulk_download endpoint exactly matching the curl format
   */
  handleBulkDownloadBillingBatches = async (rows) => {
    if (!rows || rows.length === 0) {
      this.props.notificationCenter.show(
        'Please select at least one billing batch to download',
        'warning'
      );
      return;
    }
    
    try {
      this.setState({ downloadReportsByFilterInProgress: true });
      
      // Extract batch IDs from the selected rows
      const billBatchIds = rows.map(row => row.id).filter(Boolean);      
      if (billBatchIds.length === 0) {
        this.props.notificationCenter.show(
          'No valid billing batch IDs found in the selection',
          'warning'
        );
        this.setState({ downloadReportsByFilterInProgress: false });
        return;
      }
      
      // Use the direct billing/batch/bulk_download API
      const billingResponse = await dataProvider(
        POST,
        'billing/batch/bulk_download',
        {
          data: { billBatchIds }
        }
      );
  
      // The response has already been unwrapped by dataProvider, so we need to check for the URL in the right place
      if (billingResponse && billingResponse.data && billingResponse.data.url) {
        // This is the correct path to the URL based on your actual response
        const url = billingResponse.data.url;
        window.open(url);
        this.props.notificationCenter.showDownloadNotification(url);
        
        // Show the success message from the response if available
        if (billingResponse.message) {
          this.props.notificationCenter.show(billingResponse.message, 'info');
        } else {
          this.props.notificationCenter.show(
            `Successfully initiated download for ${billBatchIds.length} billing batch(es)`,
            'info'
          );
        }
      } else {
        console.error('Could not find URL in response:', billingResponse);
        this.props.notificationCenter.show(
          'Nothing to download',
          'warning'
        );
      }
    } catch (error) {
      console.error('Error during bulk download:', error);
      this.props.notificationCenter.show(
        'Error during download process. Please try again later.',
        'error'
      );
    } finally {
      this.setState({ downloadReportsByFilterInProgress: false });
    }
  };

  handleBulkDownloadOnlyIsDownloadable = (rows) => {
    const filteredRows = filter(rows, { isDownloadable: 1 })
    this.handleBulkDownload(filteredRows);
  }

  handleBulkDownload = async (rows, callSource = "RESULT") => {
    try {
      const response = await dataProvider(
        DOWNLOAD_FILE,
        `requisitions/bulk_download`,
        {
          data: {
            reqIds: helpers.getAllValues(rows, "id"),
            callSource,
          },
        },
        {
          apiEndointType: "report"
        }
      );

      if (response.data !== null && response.data.hasOwnProperty("url")) {
        window.open(response.data.url);
        this.props.notificationCenter.showDownloadNotification(
          response.data.url
        );
      } else {
        this.props.notificationCenter.show(response.message, "error");
      }
    } catch (error) {
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  handleBulkNotify = async (rows) => {
    try {
      await dataProvider(
        UPDATE_LIST,
        `requisitions/send_notif`,
        {
          data: {
            reqIds: helpers.getAllValues(rows, "id"),
          },
        },
      );
      this.reloadTable();
    } catch (error) {
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  handleBulkNextStatusLogSource = (rows) => {
    this.handleNextStatus(rows, "LOG");
  };

  handleBulkNextStatusAccSource = (rows) => {
    this.handleNextStatus(rows, "ACC");
  };

  handleBulkNextStatusResultSource = (rows) => {
    this.handleNextStatus(rows, "RESULT");
  };

  handleBulkNextStatusReportSource = (rows) => {
    this.handleNextStatus(rows, "REPORT");
  };

  handleBulkNextStatusReleaseSource = (rows) => {
    this.handleNextStatus(rows, "RELEASE");
  };

  handleNextStatus = (rows, callSource) => {
    dataProvider(
      UPDATE,
      `requisitions/${
        rows[0].reqStatusCode
      }/next_status/bulk_move?id=${helpers.getAllValues(rows, "id")}`,
      {
        data: {
          callSource: callSource,
        },
      }
    )
      .then((response) => {
        this.props.notificationCenter.show(
          `Successfully updated status`,
          "info"
        );
        this.smartTable.loadData();
        this.statusBar.loadData();
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
      });
  };

  handleDeliveryClick = (rows) => {
    this.setState(
      {
        deliveryReqID: rows[0].id,
        deliveryModalType: "single",
      },
      () => {
        this.props.handleOpenModal();
      }
    );
  };

  handleBulkDeliveryClick = (rows) => {
    this.setState(
      {
        selectedRows: rows,
        deliveryModalType: "bulk",
      },
      () => {
        this.props.handleOpenModal();
      }
    );
  };

  handleGoToStatus = (rows) => {
    let reqStatusCode = null;

    if (rows[0].reqStatusCode === "RELEASE") {
      reqStatusCode = "ACC";
    } else {
      return;
    }

    dataProvider(UPDATE, `requisitions`, {
      data: { reqStatusCode: reqStatusCode },
      id: rows[0].id,
    })
      .then((response) => {
        this.props.notificationCenter.show(
          `Successfully updated status`,
          "info"
        );
        this.smartTable.loadData();
        this.statusBar.loadData();
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
      });
  };

  handleSubTableRowsInputData = (data) => {
    const { inputDataByHash, row, parentRow } = data;

    this.setState((prevState) => {
      const parentRowID = parentRow.id;

      let updatedRow = {};

      if (prevState.resultsInputData.hasOwnProperty(parentRowID)) {
        updatedRow = {
          resultsInputDataById: prevState.resultsInputData[
            parentRow.id
          ].resultsInputDataById.includes(row.id)
            ? prevState.resultsInputData[parentRow.id].resultsInputDataById
            : prevState.resultsInputData[
                parentRow.id
              ].resultsInputDataById.concat(row.id),
          resultsInputDataByHash: {
            ...prevState.resultsInputData[parentRow.id].resultsInputDataByHash,
            [row.id]: inputDataByHash.result,
          },
        };
      } else {
        updatedRow = {
          resultsInputDataById: [row.id],
          resultsInputDataByHash: { [row.id]: inputDataByHash.result },
        };
      }

      return {
        resultsInputData: {
          ...prevState.resultsInputData,
          [parentRow.id]: updatedRow,
        },
      };
    });
  };


  reloadTable = () => {
    this.smartTable.loadData();
  };

  /**
   * Fetches billing batches from the API
   * @returns {Promise<Object>} Response from the API
   */
  handleFetchBillingBatch = async () => {
    try {
      // Matching your successful curl format exactly
      const response = await dataProvider(
        GET_LIST,
        'billing/batch',
       
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );      
      if (response && response.data) {
        console.table(response.data);
        this.props.notificationCenter.show(
          `Successfully fetched ${response.data.length} billing batches`, 
          "info"
        );
      } else {
        this.props.notificationCenter.show("No billing batches found", "warning");
      }
      
      return response;
    } catch (error) {
      console.error('Billing Batch API Error:', error);
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  /**
   * Fetches details of a specific billing batch
   * @param {number} batchId - ID of the batch to fetch details for
   * @returns {Promise<Object>} Response from the API
   */
  handleFetchBillingBatchDetails = async (batchId = 1) => {
    try {
      // Using same token format for consistency
      const response = await dataProvider(
        GET_ONE,
        `billing/batch/details/${batchId}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );      
      if (response && response.data) {
        console.table(response.data);
        this.props.notificationCenter.show(
          `Successfully fetched details for billing batch #${batchId}`, 
          "info"
        );
      } else {
        this.props.notificationCenter.show(`No details found for billing batch #${batchId}`, "warning");
      }
      
      return response;
    } catch (error) {
      console.error(`Billing Batch Details API Error for ID ${batchId}:`, error);
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  /**
   * Handles the download of billing batch details for a specific requisition ID
   * Uses the exact API endpoint format from the curl command
   * @param {object} row - The row data containing the requisition ID
   */
  handleBillingDetailsDownload = (row) => {
    try {      
      // For sub-table rows, we need to use the requisitionId (reqId) field
      // Make sure we're getting the correct ID from the row data
      let reqId;
      
      if (typeof row === 'object') {
        // If row is a full object with properties
        reqId = row.reqId || row.requisitionId || row.id;
      } else {
        // If row is a direct ID value
        reqId = row;
      }
      
      if (!reqId) {
        this.props.notificationCenter.show("No requisition ID found in selected row", "warning");
        return;
      }

      // Using the direct API endpoint with v3.0 prefix as specified in the curl command      
      dataProvider(
        POST,
        `billing/batch/details/download/${reqId}`,
        { data: {} }
      )
        .then((response) => {          
          // Extract URL from response
          let url;
          if (response.data && response.data.url) {
            url = response.data.url;
          } else if (response.data && response.data.data && response.data.data.url) {
            url = response.data.data.url;
          }
          
          if (url && typeof url === "string") {
            window.open(url, "_blank");
            this.props.notificationCenter.showDownloadNotification(url);
            this.props.notificationCenter.show(
              `Successfully downloaded details for requisition #${reqId}`,
              "info"
            );
          } else {
            console.error("Could not find URL in response:", response);
            this.props.notificationCenter.show(
              "Nothing to download",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.error(`Error downloading billing batch details for requisition ID ${reqId}:`, error);
          this.props.notificationCenter.show(error.message, "error");
        });
    } catch (error) {
      console.error("Error in handleBillingDetailsDownload:", error);
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  handleDownloadReportsByFilter = () => {
    this.setState({
      downloadReportsByFilterInProgress: true,
    });
    dataProvider(
      GET_LIST,
      `${getResource(this.state.currentFilterStatus)}/export`,
      {
        filter: { ...this.props.smartFilter.getFilter() },
      },
      {
        apiEndointType: 'report',
      }
    )
      .then(({ data, total, message }) => {

        if (data !== null && data.hasOwnProperty("url")) {
          window.open(data.url);
          this.props.notificationCenter.show(
            "If download failed, please click here",
            "info",
            "Download",
            () => {},
            data.url
          );
        } else {
          this.props.notificationCenter.show(message, "error");
        }
        this.setState({
          downloadReportsByFilterInProgress: false,
        });
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
        this.setState({
          downloadReportsByFilterInProgress: false,
        });
      });
  };

  render() {
    const {
      deliveryReqID,
      selectedRows,
      deliveryModalType,
    } = this.state;
    const {
      modalOpen,
      handleCloseModal,
      tableColConfigByHashWithExtraData,
    } = this.props;

    const tableFilter = this.props.smartFilter.getFilter();

    const currentColumnGroup =
      tableColConfig.groupsByHash[this.state.currentFilterStatus];
    let columns = currentColumnGroup;

    if (currentColumnGroup.hasOwnProperty("tableColById")) {
      columns = helpers.byHashByIDConfToArray(
        currentColumnGroup.tableColById,
        tableColConfigByHashWithExtraData || currentColumnGroup.tableColByHash
      );
    }

    const actionHandlers = {
      handleGoToStatus: this.handleGoToStatus,
      handleNextStatus: this.handleNextStatus,
      handleBulkNextStatusLogSource: this.handleBulkNextStatusLogSource,
      handleBulkNextStatusAccSource: this.handleBulkNextStatusAccSource,
      handleBulkNextStatusReportSource: this.handleBulkNextStatusReportSource,
      handleBulkNextStatusResultSource: this.handleBulkNextStatusResultSource,
      handleBulkNextStatusReleaseSource: this.handleBulkNextStatusReleaseSource,
      handlePrintCryoAction: this.handlePrintCryoAction,
      handlePrintBarCodeAction: this.handlePrintBarCodeAction,
      handleBulkDownloadResultSource: this.handleBulkDownloadResultSource,
      handleBulkDownloadReportSource: this.handleBulkDownloadReportSource,
      handleBulkDownloadReleaseSource: this.handleBulkDownloadReleaseSource,
      handleBulkDownloadDeliverSource: this.handleBulkDownloadDeliverSource,
      handleDeliveryClick: this.handleDeliveryClick,
      handleBulkDownload: this.handleBulkDownload,
      handleBulkNotify: this.handleBulkNotify,
      handleBulkDownloadOnlyIsDownloadable: this.handleBulkDownloadOnlyIsDownloadable,
      handleBulkDeliveryClick: this.handleBulkDeliveryClick,
      handleSaveTestResults: this.handleSaveTestResults,
      handleFetchBillingBatch: this.handleFetchBillingBatch,
      handleFetchBillingBatchDetails: this.handleFetchBillingBatchDetails,
      handleBillingDetailsDownload: this.handleBillingDetailsDownload,
      handleBulkDownloadBillingBatches: this.handleBulkDownloadBillingBatches,
    };

    const smartFilterConfig = getSmartFilterConfig();
    const filteredByPermissionsSmartFilterConfig = filterArrayConfigByPermissions(smartFilterConfig, this.props.authCenter.access.userRoleCode);
    const headerTitle = helpers.can([userRoles.billing]) ? "Billed Requisitions" : "Requisitions";

    return (
      <div>
        <DeliveryModalContainer
          modalOpen={modalOpen}
          handleCloseModal={handleCloseModal}
          resource={
            deliveryModalType === "single"
              ? `requisitions/${deliveryReqID}/rep_delivery`
              : `requisitions/bulk_delivery`
          }
          handleSubmitOK={this.reloadTable}
          submitData={
            deliveryModalType === "single"
              ? {}
              : {
                  reqIds: helpers.getAllValues(selectedRows, "id"),
                }
          }
        />

        <MainHeader
          title={headerTitle}
          showFilterButton={true}
          button={
            <Can
              allowedRoles={[
                userRoles.admin,
                userRoles.management,
                userRoles.lisstaff,
              ]}
            >
              <AddPostButton title="Requisitions" href="/requisitions/create" />
            </Can>
          }
        />
        <SearchBar />
      <SmartViewsSidebar
            isOpen={true}
            resource="requisitions"
            smartFilterConfig={filteredByPermissionsSmartFilterConfig}
          >
            <div className="mainContainer">
              <div className="mainContainer__inner">
                <Can allowedRoles={userGroups.superAdmins}>
                  <StatusBarContainer
                    onRef={(ref) => (this.statusBar = ref)}
                    handleChangeStatus={this.handleChangeStatus}
                    currentFilterStatus={this.state.currentFilterStatus}
                  />
                </Can>
                <SmartTable
                    {...getExtraTableConfiguration({
                      status: this.state.currentFilterStatus,
                      actionHandlers: actionHandlers,
                      smartFilter: this.props.smartFilter.getFilter(), // Pass FULL filter (includes requisition fields) for sub-table
                      resultsInputData: this.state.resultsInputData,
                    })}
                    onRef={(ref) => (this.smartTable = ref)}
                    columns={columns}
                    filter={tableFilter}
                    resource={getResource(this.state.currentFilterStatus)}
                    showDelete={false}
                    handleSubTableRowsInputData={this.handleSubTableRowsInputData}
                    extraDataConfig={extraDataConfig}
                    order={"desc"}
                    actionHandlers={actionHandlers}
                    toolbarExtraComponents={
                      <React.Fragment>
                        <Can notAllowedRoles={[userRoles.client, userRoles.physician, userRoles.sales, userRoles.billing, userRoles.collaborator]}>
                          <TableHeaderAddButton
                            icon={<Delivery2Icon />}
                            onClick={this.handleDownloadReportsByFilter}
                            showProgressBar={
                              this.state.downloadReportsByFilterInProgress
                            }
                          >
                            Export All
                          </TableHeaderAddButton>
                        </Can>
                      </React.Fragment>
                    }
                  />
              </div>
              <Footer />
            </div>
          </SmartViewsSidebar>
      </div>
    );
  }
}

export default compose(
  withAuthCenter(),
  withSmartFilter(),
  withModal,
  withNotificationCenter()
)(RequisitionsListComponent);
